import React from 'react'
import useAxiosPrivate from '../apis/useAxiosPrivate';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const CUSTOMER_BLOCK_URL = `/customers/{customerId}/block`;
const CUSTOMER_UNBLOCK_URL = `/customers/{customerId}/unblock`;


const SwitchInput = ({ currentUser, onSetChangedData }) => {
    const { i18n } = useTranslation();
    const [isChecked, setIsChecked] = React.useState(currentUser.blocked);
    const axiosPrivate = useAxiosPrivate();

    const handleBlockCustomer = async (e) => {

        if (currentUser.blocked) {
            setIsChecked(!currentUser.blocked)
            try {
                const unblockResponse = await axiosPrivate.post(CUSTOMER_UNBLOCK_URL.replace('{customerId}', currentUser.customerId),
                    { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } }
                );

                console.log('unblock-response: ', unblockResponse);


                onSetChangedData(unblockResponse?.data?.data?.customer);
                toast.success(unblockResponse?.data.message);
            } catch (error) {
                setIsChecked(currentUser.blocked)
                toast.error(error.response?.data.message);
            }
        } else {

            setIsChecked(!currentUser.blocked)
            try {
                const blockResponse = await axiosPrivate.post(CUSTOMER_BLOCK_URL.replace('{customerId}', currentUser.customerId),
                    { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } }
                );

                console.log('block-response: ', blockResponse);


                onSetChangedData(blockResponse?.data?.data?.customer);
                toast.success(blockResponse?.data.message);
            } catch (error) {
                setIsChecked(currentUser.blocked)
                toast.error(error.response?.data.message);
            }

        }

    }

    return (
        <div className="">
            <input
                className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-gray-400 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-gray-200 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary-color checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s]"
                type="checkbox"
                role="switch"
                id={"flexSwitchCheckDefault-" + currentUser.userId}
                checked={isChecked}
                onChange={handleBlockCustomer} />
        </div>
    )
}

export default SwitchInput